import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert } from "lucide-react";

const ROLE_COLOR = {
  admin: "bg-purple-100 text-purple-700",
  teacher: "bg-emerald-100 text-emerald-700",
  parent: "bg-sky-100 text-sky-700",
};

export default function AuditLogPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-log").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-black text-slate-900">سجل التدقيق</h1>
        <p className="text-slate-500 mt-2">كل من دخل وشاف أي ملف — مهم قانونياً لبيانات حساسة</p>
      </div>
      <Card className="border-slate-200/70 card-elevated">
        <CardContent className="p-0">
          <div className="divide-y divide-slate-200">
            {items.map((a) => (
              <div key={a.id} data-testid={`audit-${a.id}`} className="p-4 flex items-start gap-4 hover:bg-slate-50">
                <div className="w-10 h-10 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0">
                  <ShieldAlert className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-bold text-slate-900">{a.actor_email}</span>
                    <Badge className={`${ROLE_COLOR[a.actor_role]} hover:${ROLE_COLOR[a.actor_role]}`}>{a.actor_role}</Badge>
                    <span className="text-slate-600 text-sm">→ {a.action}</span>
                    <span className="text-xs text-slate-500">({a.target_type})</span>
                  </div>
                  {a.details && <div className="text-xs text-slate-500 mt-1">{a.details}</div>}
                </div>
                <div className="text-xs text-slate-400 shrink-0">{new Date(a.timestamp).toLocaleString("ar-EG")}</div>
              </div>
            ))}
            {items.length === 0 && <div className="p-16 text-center text-slate-400">لا يوجد سجل بعد</div>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
